import { Helmet } from 'react-helmet'

interface SEOProps {
  title: string
  description: string
  keywords?: string
  canonicalUrl?: string
  ogImage?: string
  jsonLd?: Record<string, any> | Record<string, any>[]
  noindex?: boolean
}

export function SEO({
  title,
  description,
  keywords,
  canonicalUrl,
  ogImage = 'https://res.cloudinary.com/dz92jtvzt/image/upload/v1774278701/logo-no-bg_vbyfqb.png', // Image (logo) par défaut pour les réseaux sociaux
  jsonLd,
  noindex = false
}: SEOProps) {
  const siteName = 'JE Pro Group'
  const fullTitle = title.includes(siteName) ? title : `${title} | ${siteName}`
  const facebookAppId = (import.meta as any).env?.VITE_FACEBOOK_APP_ID

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      
      {/* Open Graph (LinkedIn, Facebook, WhatsApp, etc.) */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
      <meta property="og:site_name" content={siteName} />
      {facebookAppId && <meta property="fb:app_id" content={facebookAppId} />}
      
      {/* JSON-LD (Données Structurées pour Google) */}
      {jsonLd && (
        Array.isArray(jsonLd)
          ? jsonLd.map((block, i) => (
              <script key={i} type="application/ld+json">
                {JSON.stringify(block)}
              </script>
            ))
          : (
            <script type="application/ld+json">
              {JSON.stringify(jsonLd)}
            </script>
          )
      )}
    </Helmet>
  )
}
